import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';
import { SESSION_STORAGE_KEY } from '../configs';
import { APP_ROLE, ROUTE_PATH, type AppRole } from '../constants';
import { AuthStateService } from '@core/services/auth-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private sessionStorageService: SessionStorageService,
    private authStateService: AuthStateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const accessToken = this.authStateService.accessToken ?? "";

    if (!accessToken) {
      return this.router.createUrlTree([`/${ROUTE_PATH.LOGIN}`]);
    }

    const allowedRoles = route.data['allowedRoles'] as readonly AppRole[] | undefined;
    if (!allowedRoles?.length) {
      return true;
    }

    const currentRole = this.getCurrentRole();
    if (currentRole && allowedRoles.includes(currentRole)) {
      return true;
    }

    if (!currentRole) {
      return this.router.createUrlTree([`/${ROUTE_PATH.LOGIN}`]);
    }

    return this.router.createUrlTree([`/${this.getDefaultRouteForRole(currentRole)}`]);
  }

  private getCurrentRole(): AppRole | null {
    const userInfo = this.sessionStorageService.getSessionData<{ roleId?: string }>(SESSION_STORAGE_KEY.userInfo);
    const roleId = userInfo?.roleId ?? this.sessionStorageService.getSessionData<string>(SESSION_STORAGE_KEY.roleId);

    if (roleId === APP_ROLE.ADMIN || roleId === APP_ROLE.TEACHER || roleId === APP_ROLE.STUDENT) {
      return roleId;
    }

    return null;
  }

  private getDefaultRouteForRole(role: AppRole): string {
    return role === APP_ROLE.ADMIN ? ROUTE_PATH.ADMIN_USERS : ROUTE_PATH.HOME;
  }
}
